import Component from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';

/**
 * A circle with a plus icon to add a new story.
 * Displayed first in the story bar if the actor has permission.
 *
 * Props:
 *   onclick – callback when circle is tapped
 */
export default class AddStoryCircle extends Component {
  view() {
    const { onclick } = this.attrs;
    const user = app.session.user;

    return (
      <div className="StoryCircle StoryCircle--add" onclick={onclick}>
        <div className="StoryCircle-ring StoryCircle-ring--viewed">
          <div className="StoryCircle-inner">
            <div className="StoryCircle-plusIcon">
              {icon('fas fa-plus')}
            </div>
          </div>
        </div>
        <span className="StoryCircle-name">{app.translator.trans('happydigital-stories.forum.add_story')}</span>
      </div>
    );
  }
}
